import _ from "lodash";
import React from "react";
import { connect } from "react-redux";

import classNames from "classnames";
import classes from "./UnitCard.scss";
import { getRethumbUrl } from "Utils";
import {
  PLACEHOLDER_RECT_IMAGE,
  PLACEHOLDER_RECT_IMAGE_COUNT,
} from "Constants";
import { updateSelectedUnit } from "AppComponents/LEIntoUnitImport/modules/Module";
import MoreItemWithToolTip from "UIComponents/MoreItemWithToolTip";

import { TickCircleFilled } from "@toddle-edu/ds-icons";

const styles = {
  tooltipContainerStyle: {
    maxWidth: "150px",
    maxHeight: "250px",
    overflowY: "auto",
  },
  tooltipMoreStyle: {
    display: "inline",
  },
};

function UnitCard({
  unitPlanInfo,
  index,
  isSelected,
  updateSelectedUnit,
  unitCardRefs,
  onKeyDown = _.noop,
}) {
  const { id, title, subjects = [] } = unitPlanInfo;
  let { imageUrl } = unitPlanInfo;

  const subjectLabels = _.map(subjects, "name");

  if (_.isEmpty(imageUrl)) {
    imageUrl = PLACEHOLDER_RECT_IMAGE[index % PLACEHOLDER_RECT_IMAGE_COUNT];
  }

  const rethumbUrl = getRethumbUrl({
    width: 320,
    height: 160,
    imageUrl,
    fitIn: false,
  });

  const onClickUnit = () => {
    const newUnitPlanInfo = isSelected ? {} : unitPlanInfo;
    updateSelectedUnit(newUnitPlanInfo);
  };

  const handleTabPress = e => {
    const container = unitCardRefs?.current?.[id];
    const tooltipElements = Array.from(
      container.querySelectorAll('[tabindex="-1"]')
    );
    const currentIndex = tooltipElements.indexOf(e.target);

    if (e.shiftKey) {
      // If focus is on tooltip which is not the first tooltip element, move it to previous tooltip
      // if it is the first tooltip element, move it to the card itself
      if (currentIndex >= 0) {
        currentIndex === 0
          ? container?.focus()
          : tooltipElements?.[currentIndex - 1]?.focus();
        e.preventDefault();
        return;
      }
      return;
    } else {
      // For Tab: if focus is not on a tooltip, focus the first tooltip.
      if (currentIndex === -1 && _.size(tooltipElements) > 0) {
        e.preventDefault();
        _.first(tooltipElements)?.focus();
        return;
      }
      // If focus is on a tooltip and it's not the last one, move to the next tooltip.
      if (currentIndex !== -1 && currentIndex < _.size(tooltipElements) - 1) {
        e.preventDefault();
        tooltipElements?.[currentIndex + 1]?.focus();
        return;
      }
    }
    // If no matching condition, allow default tab behavior.
    return;
  };

  const handleKeyDown = e => {
    if (e.key === "Enter" && e.shiftKey) return;

    if (e.key === "Tab") {
      handleTabPress(e);
      return;
    }

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClickUnit();
    } else {
      onKeyDown(e);
    }
  };

  return (
    <button
      className={classes.container}
      onClick={onClickUnit}
      data-test-id={`appComponents-leIntoUnitImport-unitCard-${id}`}
      ref={ref => {
        if (unitCardRefs?.current) {
          unitCardRefs.current[id] = ref;
        }
      }}
      tabIndex={index === 0 ? 0 : -1} // focus the 1st card using tab, after that use arrow keys for navigation
      onKeyDown={handleKeyDown}
    >
      <div className={classes.imageContainer}>
        <img src={rethumbUrl} alt={title} className={classes.image} />
        {isSelected ? (
          <div className={classes.tick}>
            <TickCircleFilled variant={"success"} size={"small"} />
          </div>
        ) : null}
      </div>
      <div className={classes.infoContainer}>
        <div className={classNames("heading-6", classes.unitTitle)} dir="auto">
          {title}
        </div>
        <div className={classNames("body-2", classes.subject)} dir="auto">
          <MoreItemWithToolTip
            items={subjectLabels}
            tooltipPlacement={"right"}
            length={1}
            moreAll={true}
            trigger={["hover", "focus"]}
            tabIndex={-1}
            tooltipContainerStyle={styles.tooltipContainerStyle}
            moreStyle={styles.tooltipMoreStyle}
            closeOnScroll={true}
          />
        </div>
      </div>
    </button>
  );
}

const mapActionCreators = { updateSelectedUnit };

export default connect(null, mapActionCreators)(UnitCard);
